export default __webpack_public_path__ + "static/media/snow.b7820230.png";